import script from "./SecondDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondDevice.vue?vue&type=script&setup=true&lang=js"

import "./SecondDevice.vue?vue&type=style&index=0&id=7f852108&lang=scss"

const __exports__ = script;

export default __exports__